import React, { Suspense, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Modal, { Body, Footer, Header } from "~/common/ModalReact";
import useIsMounted from "~/common/useIsMounted";
import Button from "~/common/Buttons";
import VirtualGrouping from "~/ProductDetails/VirtualGrouping";
import { ProductDetailGroupingSelect } from "~/ProductDetails/ProductDetailPageResult";
import { User } from "../Store/models/User";

interface Props {
  productDetailGroupingSelect: ProductDetailGroupingSelect[];
  handleVirtualGroupingSelectChange?: (itemNumber: string) => string;
  setOpenModal: (openModal: boolean) => void;
  openModal: boolean;
  isVirtualGroupMaster: boolean;
  itemNumber: string;
  leaveReviewHandler: () => void;
  user: User;
}

const ReviewVgItemSelectionModal = ({
  productDetailGroupingSelect,
  handleVirtualGroupingSelectChange,
  setOpenModal,
  openModal,
  isVirtualGroupMaster,
  itemNumber,
  leaveReviewHandler,
  user,
}: Props) => {
  const isMounted = useIsMounted();

  const [displayLeaveReviewError, setDisplayLeaveReviewError] = useState(false);
  const handleLeaveReviewClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    setDisplayLeaveReviewError(false);

    if (isVirtualGroupMaster) {
      setDisplayLeaveReviewError(true);
      return;
    }

    setOpenModal(false);
    leaveReviewHandler();
  };

  useEffect(() => {
    setDisplayLeaveReviewError(false);
  }, [isVirtualGroupMaster]);

  if (!handleVirtualGroupingSelectChange) {
    return <></>;
  }

  return (
    <>
      {isMounted &&
        ReactDOM.createPortal(
          <Suspense fallback={null}>
            <Modal
              isOpen={openModal}
              onRequestClose={() => {
                setOpenModal(false);
              }}
              className="md:max-w-sm"
            >
              <Header
                closeModal={() => {
                  setOpenModal(false);
                }}
              >
                <h3 className="flex text-base m-0 md:text-xl">
                  Select Product Options
                </h3>
              </Header>
              <Body>
                <>
                  <div className="m-5">
                    <VirtualGrouping
                      productGroupingSelect={productDetailGroupingSelect}
                      handleVirtualGroupingSelectChange={
                        handleVirtualGroupingSelectChange
                      }
                      virtualGroupMemberToDisplay=""
                      user={user}
                      showPricingInDropdown={false}
                    />
                  </div>
                  {displayLeaveReviewError && (
                    <div
                      className="add-to-cart"
                      style={{
                        fontSize: "14px",
                        marginBottom: "10px",
                        marginTop: "-18px",
                      }}
                    >
                      <p
                        className="messages"
                        data-testid="review-vg-item-select-messages"
                      >
                        Please select{" "}
                        {(productDetailGroupingSelect[0]?.configurationOptions
                          .length ?? 0) > 1
                          ? "options"
                          : "an option"}{" "}
                        for this product.
                      </p>
                    </div>
                  )}
                </>
              </Body>
              <Footer>
                <Button
                  className="btn btn btn-primary btn-block"
                  data-testid="vg-select-review-button"
                  color="green"
                  href={`/myaccount.cfm?goto=myreviews&item_number=${itemNumber}`}
                  id="leaveReviewButton"
                  onClick={handleLeaveReviewClick}
                >
                  Leave a Review
                </Button>
                <Button
                  className="ml-3"
                  color="light"
                  aria-label="Cancel"
                  type="button"
                  onClick={() => setOpenModal(false)}
                  data-testid="review-vg-select-close-button"
                >
                  Close
                </Button>
              </Footer>
            </Modal>
          </Suspense>,

          document.querySelector("body") as Element,
        )}
    </>
  );
};

export default ReviewVgItemSelectionModal;
